import { AbsoluteFill, Img, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
import { useEffect } from "react";

interface SeccionInterface {
	name: string,
	title: string,
	text: string
}

export const GraciasSection = ({ name, title, text }: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps } = useVideoConfig();
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);

	const titleScale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});
	const titleOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});

	const titleTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 0
	});

	const subtitleOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 15
	});

	const subtitleTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 15
	});

	// ? LOGO
	const logoScale = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 40
	});
	const logoOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 40
	});

	const logoTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 40
	});
	const subtitle2Opacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 55
	});

	const subtitle2Translate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 30,
		to: 0,
		delay: 55
	});

	return (
		<AbsoluteFill>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D"
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/12_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="text-wrap" style={{
					position: "absolute",
					top: "50%",
					width: "100%",
					textAlign: "center",
					transform: "translateY(-50%)",
				}}>
					<div className="text">
						<h1 style={{
							fontSize: 79,
							fontWeight: 500,
							color: "#fff",
							margin: 0,
							marginBottom: 30,
							lineHeight: 0.8,
							textAlign: "center",
							opacity: titleOpacity,
							transform: `translateY(${titleTranslate}px) scale(${titleScale})`
						}}>{title}<span style={{
							color: "#000"
						}}>!</span></h1>
						<h4 style={{
							fontSize: 59,
							margin: 0,
							color: "#fff",
							fontWeight: 500,
							lineHeight: 0.8,
							opacity: subtitleOpacity,
							transform: `translateY(${subtitleTranslate}px)`
						}}>{name}</h4>
					</div>
					<div className="text-news" style={{
						marginTop: 192
					}}>
						<div className="logo" style={{
							marginTop: 20,
							opacity: logoOpacity,
							transform: `translateY(${logoTranslate}px) scale(${logoScale})`
						}}>
							<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-red-logo.svg")} style={{
								display: "block",
								width: "100%",
								margin: "auto",
								maxWidth: 316
							}} />
						</div>
						<p style={{
							margin: 0,
							fontSize: 79,
							color: "#fff",
							fontWeight: 500,
							opacity: subtitle2Opacity,
							transform: `translateY(${subtitle2Translate}px)`
						}}>{text}</p>
					</div>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};